module.exports = "/_next/static/images/Recovery@3x-0ade616c276fefd89050ba2b60474b6e.png";